import { WHEEL_STEP } from "./viewport";

export type WheelAction =
  | { kind: "zoom"; factor: number }
  | { kind: "pan"; dx: number; dy: number }
  | { kind: "none" };

interface WheelLike { deltaX: number; deltaY: number; deltaMode: number; ctrlKey: boolean; metaKey: boolean; shiftKey: boolean }

/** A touchpad sends small, fractional or two-axis pixel deltas; a wheel sends whole notches (WheelEvent has no device flag). */
export function looksLikeTrackpad(e: WheelLike): boolean {
  if (e.deltaMode !== 0) return false;
  return e.deltaX !== 0 || !Number.isInteger(e.deltaY) || Math.abs(e.deltaY) < 40;
}

/**
 * annotation_canvas.wheelEvent in browser terms:
 *   Ctrl+wheel and pinch zoom at the cursor (a pinch arrives as ctrl+wheel);
 *   two-finger scroll pans; Shift+wheel pans sideways; a plain wheel zooms at the cursor.
 */
export function decodeWheel(e: WheelLike): WheelAction {
  if (!e.deltaX && !e.deltaY) return { kind: "none" };
  const notches = e.deltaMode === 1 ? -e.deltaY / 3 : -e.deltaY / 100;       // wheel up = zoom in
  const pinch = e.ctrlKey && looksLikeTrackpad(e);
  if (pinch) return { kind: "zoom", factor: Math.exp(-e.deltaY * 0.01) };
  if (e.ctrlKey || e.metaKey) return notches ? { kind: "zoom", factor: WHEEL_STEP ** notches } : { kind: "none" };
  if (looksLikeTrackpad(e)) return { kind: "pan", dx: -e.deltaX, dy: -e.deltaY };
  if (e.shiftKey) return { kind: "pan", dx: -(e.deltaY || e.deltaX), dy: 0 };
  if (e.deltaY) return { kind: "zoom", factor: WHEEL_STEP ** notches };
  if (e.deltaX) return { kind: "pan", dx: -e.deltaX, dy: 0 };
  return { kind: "none" };
}
